class Tooltip {
	init() {
		jQuery(window).on('click', function () {
			jQuery('.has-tooltip').removeClass('open');
		});

		jQuery('.has-tooltip').on('click', function (e) {
			e.stopPropagation();
			jQuery(this).toggleClass('open');
		});

		let hoverTimeout;

		jQuery('.has-tooltip').on(
			'hover',
			function () {
				clearTimeout(hoverTimeout);
				jQuery(this).addClass('open');
			},
			function () {
				const self = jQuery(this);
				hoverTimeout = setTimeout(function () {
					self.removeClass('open');
				}, 1000);
			},
		);
	}
}

const instance = new Tooltip();
export default instance;
